import { render } from "./landingCards.vue?vue&type=template&id=27faace4&scoped=true"
import script from "./landingCards.vue?vue&type=script&lang=js"
export * from "./landingCards.vue?vue&type=script&lang=js"

import "./landingCards.vue?vue&type=style&index=0&id=27faace4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27faace4"]])

export default __exports__